import { constant } from "../constant";

const initialState = {
  loading: false,
  mbcSubmitId: null,
  sliderData: [],
  questionData: [],
  title: "",
  des: "",
  appointmentCount: 0,
  myJourneyGraph: {
    count: 0,
    data: [],
    user: {},
  },
};

const MbcReducer = (state = initialState, action) => {
  switch (action.type) {
    case constant.GET_MY_JOURNEY_GRAPH:
      return {
        ...state,
        loading: true,
        myJourneyGraph: {},
      };
    case constant.GET_MY_JOURNEY_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        myJourneyGraph: action.data,
      };
    case constant.GET_MY_JOURNEY_GRAPH_FAILED:
      return {
        ...state,
        loading: false,
        myJourneyGraph: {},
      };
      
    case constant.GET_MBC_DATA:
      return {
        ...state,
        loading: true,
        mbcSubmitId: null,
        appointmentCount: 0,
      };
    case constant.GET_MBC_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        mbcSubmitId: action.data.mbcSubmitId,
        sliderData: action.data.sliderData,
        questionData: action.data.questionData,
        title: action.data.title,
        des: action.data.des,
        appointmentCount: action.data.appointmentCount,
      };

    case constant.GET_MBC_DATA_FAILED:
      return {
        ...state,
        loading: false,
        mbcSubmitId: "",
        sliderData: [],
        questionData: [],
        errMsg: action.errMsg,
        title: "",
        des: "",
        appointmentCount: 0,
      };
    default:
      return state;
  }
};

export default MbcReducer;
